module.exports = __webpack_public_path__ + "static/img/SCN_DES_g.8ecd9f7e.png";